module.exports = __webpack_public_path__ + "static/media/rams-hollywood-billboard.8d438ba2.png";